import { IconBox, IconProps } from '../IconBox';

const UnassignIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path d="M9.6 10.8a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm0 2.4a7.2 7.2 0 0 1 7.2 7.2H2.4a7.2 7.2 0 0 1 7.2-7.2ZM15.6 9.6a1.2 1.2 0 1 0 0 2.4h4.8a1.2 1.2 0 1 0 0-2.4h-4.8Z" />
  </IconBox>
);

export default UnassignIcon;
